import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { Ligne } from "../../models/ligne.model";
import { LignesFacadeService } from "./lignes-facade.service";
import { StatsLigne } from "../../models/stats-ligne.model";

@Injectable({ providedIn: "root" })
export class LignesStoreService extends EntityStoreService<
  Ligne,
  EntityMetadata,
  LigneState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      stats: null,
    });
  }
}

export interface LigneState extends EntityStoreState<LignesFacadeService> {
  stats: StatsLigne;
}
